import { render } from "./ClientEstadoCuenta.vue?vue&type=template&id=3878241c&scoped=true"
import script from "./ClientEstadoCuenta.vue?vue&type=script&lang=js"
export * from "./ClientEstadoCuenta.vue?vue&type=script&lang=js"

import "./ClientEstadoCuenta.vue?vue&type=style&index=0&id=3878241c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3878241c"]])

export default __exports__